import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@ooh/ui/components/dropdown-menu';
import { Button } from '@ooh/ui/components/button';

export type SupportedLanguage = 'pl' | 'en';

export function LanguageSwitcher({
  currentLanguage,
  switchLabel,
  plLabel,
  enLabel,
  onSelect,
}: {
  currentLanguage: string;
  switchLabel: string;
  plLabel: string;
  enLabel: string;
  onSelect: (lng: SupportedLanguage) => void;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="px-2 text-xs font-medium uppercase"
          aria-label={switchLabel}
          data-testid="language-switch"
        >
          {currentLanguage}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-32">
        <DropdownMenuItem onSelect={() => onSelect('pl')} data-testid="language-switch-pl">
          {plLabel}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => onSelect('en')} data-testid="language-switch-en">
          {enLabel}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
